import { Box, Typography } from '@mui/material';
import React, { useState, useRef, useEffect, useMemo } from 'react';
import { List, AutoSizer, CellMeasurer, CellMeasurerCache } from 'react-virtualized';
import ModalHeader from '../../common/Header';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import moment from 'moment'

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
const ReportCard = ({ obj, index, isOpen, toggleOpen, measure }) => {
    useEffect(() => {
        measure();
    }, [isOpen, measure]);
    const detailsList = [
        { name: 'Cash(+)', field: 'Collection' },
        { name: 'Modify(+)', field: 'MODIFY' },
        { name: 'Modify Charge', field: 'ModificationCharges' },
        { name: 'Refund (-)', field: 'Refund' },
        { name: 'Offline Coll(+)', field: 'OfflineCollection' },
        { name: 'Online Other Collection', field: 'OnlineOthColl' },
        { name: 'Cancellation Chrg(+)', field: 'RefundCharge' },
        { name: 'Agent coll(+)', field: 'AgentCollection' },
        { name: 'Offline Other Exp', field: 'OffExp' },
        { name: 'GST', field: 'STAX' },
        { name: 'Total', field: 'Collection' },
        { name: 'Credit', field: 'Card' },
    ]
    return (
        <Box className="reportCard" >
            <Box className='header'>
                <Typography>Branch Name : {obj.BranchName || ''}</Typography>
            </Box>
            {obj.subData.map((val) => (
                <Box className="card">
                    <Box className='cardheader'>
                        <Box className='user-name' sx={{ display: 'flex', flexDirection: 'column', gap: "8px" }} >
                            <Typography sx={{
                                color: '#ff7100', fontSize: '14px',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                textTransform: 'uppercase',
                            }}>
                                {val?.UserName}
                            </Typography>
                            <Typography sx={{ fontSize: '12px' }}>Transaction Date</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: "8px" }}>
                            <Typography sx={{ fontSize: '14px', color: '#2b8959' }} > {`Rs. ${Number(val.Collection)}`}</Typography>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                <Typography sx={{ fontSize: '12px' }}>{`${moment(val.FromDate, 'DD-MMM-YYYY').format('DD MMM YY')}-${moment(val.ToDate, 'DD-MMM-YYYY').format('DD MMM YY')}`}</Typography>
                                {isOpen ? (
                                    <>
                                        <KeyboardArrowUpIcon onClick={toggleOpen} />
                                    </>
                                ) : (
                                    <>
                                        <KeyboardArrowDownIcon onClick={toggleOpen} />
                                    </>
                                )}
                            </Box>
                        </Box>
                    </Box>
                    {isOpen &&
                        <Box className='cardDetail'>
                            {detailsList.map((col, index) => (
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', padding: '4px 16px', backgroundColor: index % 2 === 0 ? '#e8f0e5' : '#fff' }}>
                                    <Typography sx={{ flex: 1.4 }}>{col.name}</Typography>
                                    <Typography sx={{ flex: 0.1 }}>:</Typography>
                                    <Typography sx={{ flex: 0.8 }}>
                                        {`Rs ${val[col.field]}`}
                                    </Typography>
                                </Box>
                            ))}
                        </Box>
                    }
                </Box>
            ))
            }
        </Box >
    );
};

const UserCollectionDetails = (props) => {
    const { reportDate = [], handleBack } = props
    const [openStates, setOpenStates] = useState({});
    const listRef = useRef(null);


    const totals = useMemo(() => {
        let totalRow = {
            Collection: 0, MODIFY: 0, ModificationCharges: 0, Refund: 0,
            OfflineCollection: 0, OnlineOthColl: 0, RefundCharge: 0,
            AgentCollection: 0, OffExp: 0, STAX: 0,
            withStaxCollection: 0, withoutstaxCollection: 0, RefundWithStax: 0, RefundWithoutStax: 0,
        };

        reportDate.forEach((obj) => {
            obj.subData?.forEach((val) => {
                Object.keys(totalRow).forEach((key) => {
                    totalRow[key] += Number(val[key] || 0);
                });
            });
        });

        return totalRow;
    }, [reportDate]);


    const toggleOpen = (index) => {
        setOpenStates((prev) => {
            const newState = { ...prev, [index]: !prev[index] };
            cache.current.clear(index, 0);
            listRef.current?.recomputeRowHeights(index);
            return newState;
        });
    };

    const cache = useRef(
        new CellMeasurerCache({
            fixedWidth: true,
            defaultHeight: 50,
        })
    );

    const rowRenderer = ({ index, key, style, parent, totals }) => {
        const obj = reportDate[index];
        const isOpen = openStates[index];
        const totalDetailsList = [
            { name: 'Cash(+)', value: totals.Collection },
            { name: 'Modify(+)', value: totals.MODIFY },
            { name: 'Modify Charge', value: totals.ModificationCharges },
            { name: 'Refund (-)', value: totals.Refund },
            { name: 'Offline Coll(+)', value: totals.OfflineCollection },
            { name: 'Online Other Collection', value: totals.OnlineOthColl },
            { name: 'Cancellation Chrg(+)', value: totals.RefundCharge },
            { name: 'Agent coll(+)', value: totals.AgentCollection },
            { name: 'Offline Other Exp', value: totals.OffExp },
            { name: 'GST', value: totals.STAX },
            { name: 'Total', value: totals.Collection },
            { name: 'Credit', field: 'Card' },
            { name: 'Coll (Cash) with GST Bkg', value: totals.withStaxCollection },
            { name: 'Coll (Cash) w/o GST Bkg', value: totals.withoutstaxCollection },
            { name: 'Refund With GST', value: totals.RefundWithStax },
            { name: 'Refund w/o GST', value: totals.RefundWithoutStax },



        ];
        return (
            <CellMeasurer key={key} cache={cache.current} columnIndex={0} rowIndex={index} parent={parent}>
                {({ measure }) => (
                    <Box style={style}>
                        {obj.isTotalRow ?
                            <Box className="totalCard" >
                                <Box className="totalHeader">
                                    <Typography>Grand Total</Typography>
                                </Box>
                                <Box className="totalDetails">
                                    {totalDetailsList.map((val, i) => (
                                        <Box key={i} sx={{ display: 'flex', justifyContent: 'space-between', paddingY: '4px' }}>
                                            <Typography sx={{ flex: 1.4 }}>{val.name}</Typography>
                                            <Typography sx={{ flex: 0.1 }}>:</Typography>
                                            <Typography sx={{ flex: 0.8 }}>Rs {val.value}</Typography>
                                        </Box>
                                    ))}
                                </Box>
                            </Box>
                            :
                            <ReportCard obj={obj} isOpen={isOpen} index={index} toggleOpen={() => toggleOpen(index)} measure={measure} />
                        }
                    </Box>
                )}
            </CellMeasurer>
        );
    };

    return (
        <Box>
            <ModalHeader headerText={"User Collection Report"} showBackArrow={true} onBackClick={handleBack} />
            <Box sx={{ paddingTop: "60px" }}>
                <Box sx={{ width: '100%', height: 'calc(100vh - 60px)' }}>
                    <AutoSizer>
                        {({ height, width }) => (
                            <List
                                ref={listRef}
                                width={width}
                                height={height}
                                rowCount={reportDate.length}
                                rowHeight={cache.current.rowHeight}
                                rowRenderer={(props) => rowRenderer({ ...props, totals })}
                                overscanRowCount={5}
                                deferredMeasurementCache={cache.current}
                                style={{ overflowX: 'hidden' }}
                            />
                        )}
                    </AutoSizer>
                </Box>
            </Box>
        </Box>
    );
};

export default UserCollectionDetails;
